module.exports = __webpack_public_path__ + "img/icon_group_4@2x.d0f770d2.png";